<template>
  <div>
    <div class="row">
      <!-- v-if="!openDay" -->

      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'informes' }">{{
                $t("informes")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("sageplancuentas") }}
            </li>
          </ol>
        </nav>
      </div>

      <!-- CABECERA DE BUSQUEDA POR NEGOCIO, TPV, FECHA INICIO, FECHA FIN (IGUAL QIE LA DE VENTASNEGOCIOS)  -->
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label for="listBusiness">{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="getTpv(), (idsTPV = [])"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="listTPV">{{ $t("TPV") }}</label>

                <div class="row">
                  <div class="col-8">
                    <el-select
                      class="select-default"
                      size="large"
                      v-model="idTpv"
                      filterable
                      @change="changeTPV()"
                      :placeholder="$t('seleccionaTpv')"
                    >
                      <el-option
                        v-for="tpv in listTpv"
                        class="select-primary"
                        :value="tpv.id"
                        :label="tpv.nameShow"
                        :key="tpv.id"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <div class="col-4">
                    <button class="btn btn-primary" @click="openModal()">
                      <i class="fa fa-filter"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaInicio") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ ok: 'Aceptar', cancel: 'Salir' }"
                  input-class="form-control"
                  v-model="datefrom"
                ></datetime>
              </div>
              <!--<div v-if="busquedaPorHoras" class="form-group">
                                <label>{{$t("horaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        type="time"
                                        :title="$t('horarioInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        format="HH:mm"
                                        v-model="hoursfrom"></datetime>
                            </div>-->
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{ $t("fechaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  v-model="dateto"
                ></datetime>
              </div>
              <!--<div v-if="busquedaPorHoras" class="form-group">
                                <label>{{$t("horaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        type="time"
                                        class="theme-numier"
                                        :title="$t('horaFin')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        format="HH:mm"
                                        v-model="hoursto"></datetime>
                            </div>-->
            </div>

            <!--<div class="col-md-2" style="margin-top: 10px">
                            <label> </label><br>
                            <div class="form-group">
                                <el-checkbox
                                        v-model="busquedaPorHoras">
                                    <strong>{{$t("buscarPorHoras")}}</strong>
                                </el-checkbox>

                            </div>

                        </div>-->

            <div class="col-md-3">
              <!-- Esto antes era 1, pero le hemos añadido las 2 de la busqueda de horas -->
              <label>&nbsp;</label>
              <div style="text-align: center" class="form-group">
                <button
                  class="btn btn-primary"
                  @click="getSAGEAsientosContables()"
                >
                  <img
                    src="static/img/sync.gif"
                    alt=""
                    v-if="loading"
                    width="20"
                  />
                  {{ $t("consultar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <template v-if="listSage && listSage.length > 0">
          <div class="table-responsive">
            <div>
              <template>
                <table
                  class="table table-bordered table-striped tableVentas text-nowrap"
                >
                  <thead class="thead-dark">
                    <tr style="cursor: pointer">
                      <th>
                        {{ $t("ejercicio") }}
                      </th>

                      <th>
                        {{ $t("fechaAsiento") }}
                      </th>

                      <th>
                        {{ $t("nombreTpv") }}
                      </th>

                      <th>
                        {{ $t("comentario") }}
                      </th>

                      <th>
                        {{ $t("importeAsiento") }}
                      </th>

                      <th>
                        {{ $t("serie") }}
                      </th>

                      <!-- FACTURAS FUERA TEMPORALMENTE -->
                      <!--<th>
                                            {{$t("factura")}}
                                        </th>
                                        <th>
                                            {{$t("suFacturaNo")}}
                                        </th>
                                        <th>
                                            {{$t("fechaFactura")}}
                                        </th>
                                        <th>
                                            {{$t("tipoFactura")}}
                                        </th>
                                        <th>
                                            {{$t("codigoCuentaFactura")}}
                                        </th>-->
                      <th>
                        {{ $t("descargarComoTxt") }}
                      </th>
                    </tr>
                  </thead>
                  <!-- CUERPO DE LA TABLA -->
                  <tbody>
                    <tr
                      v-for="sage in listSage"
                      style="cursor: pointer"
                      class="trDay"
                      :key="sage.Comentario"
                    >
                      <td>{{ sage.ejercicio | parseDate }}</td>
                      <td>{{ sage.FechaAsiento | parseDate }}</td>
                      <td>{{ sage.nombreTpv }}</td>
                      <td>{{ sage.Comentario }}</td>
                      <td>
                        {{ sage.ImporteAsiento | currency }}
                        <i
                          v-if="sage.CargoAbono == 'D'"
                          style="color: red"
                          class="fas fa-money-bill-wave"
                          title="La carga abono es 'D'"
                        ></i>
                        <i
                          v-else-if="sage.CargoAbono == 'H'"
                          style="color: green"
                          class="fas fa-money-bill-wave"
                          title="La carga abono es 'H'"
                        ></i>
                      </td>
                      <td>{{ sage.Serie }}</td>
                      <td
                        @click="descargarTxtSage(sage.idTpv, sage.Comentario)"
                      >
                        <i
                          style="black"
                          class="fas fa-file-download fa"
                          title="Descargar asiento contable"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="listSage && listSage.length <= 0 && loading">
          <div class="alert alert-primary" role="alert">
            {{ $t("cargandoAsientosContables") }}
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayAsientosContablesEnEsteTpvEnEsteRangoDeFecha") }}
          </div>
        </template>
      </div>
    </div>
    <modal
      name="filtradoTPV"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("filtrarPorTPV") }}</h4>
        </div>
        <div class="modal-body">
          <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
            <el-checkbox
              v-for="tpv in listCheckBoxTpv"
              :label="tpv.id"
              :key="tpv.id"
              border
            >
              {{ tpv.nameShow }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button class="btn btn-primary" @click="getSAGEAsientosContables()">
              <i class="fa fa-search"></i>
              {{ $t("filtrarTPV") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Datetime from "vue-datetime";
import {
  Button,
  ButtonGroup,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import download from "downloadjs";

export default {
  //ESTO NO SE SE HA UTILIZADO NUNCA NI SE VA A UTILIZAR, ES DEL PRIMER ACERCAMIENTO A SAGE
  created() {
    this.loading = true;
    this.$store.dispatch("setNameRoute", this.$i18n.t("sageplancuentas"));
    this.getBusiness();
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),

      hoursfrom: "00:00:00",
      hoursto: "23:59:59",

      loading: false,
      listSage: [],
      listBusinesses: [],
      listTpv: [],
      idsTPV: [],
      listCheckBoxTpv: [],
      idBusiness: 0,
      idTpv: 0,
      busquedaPorHoras: false,
    };
  },
  computed: {},
  methods: {
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function (response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTpv() {
      if (this.idBusiness.length > 0) {
        var config = {
          params: {
            idBusiness: this.idBusiness,
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
          .then(function (response) {
            if (response.data.response) {
              vm.listTpv = [];
              vm.idTpv = 0;

              for (let i = 0; i < response.data.result.length; i++) {
                vm.idsTPV.push(response.data.result[i].id);
              }
              vm.listCheckBoxTpv = response.data.result;

              let printer = {
                nameShow: vm.$t("todos"),
                id: 0,
              };
              vm.listTpv.push(printer);

              for (let i = 0; i < response.data.result.length; i++) {
                let printername = {
                  nameShow: response.data.result[i].nameShow,
                  id: response.data.result[i].id,
                };

                vm.listTpv.push(printername);
              }

              vm.getSAGEAsientosContables();
              vm.grafica = 0;
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    changeTPV() {
      if (this.listCheckBoxTpv && this.idTpv === 0) {
        this.idsTPV = [];
        for (let i = 0; i < this.listCheckBoxTpv.length; i++) {
          this.idsTPV.push(this.listCheckBoxTpv[i].id);
        }
      } else {
        this.idsTPV = [];
        this.idsTPV.push(this.idTpv);
      }

      this.getSAGEAsientosContables();
    },
    openModal() {
      this.$modal.show("filtradoTPV");
    },
    getSAGEAsientosContables() {
      this.$modal.hide("filtradoTPV");

      if (this.idBusiness.length > 0) {
        if (this.datefrom === null || this.dateto === null) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          if (this.busquedaPorHoras) {
            this.getSAGEAsientosContablesConHoras();
          } else {
            this.getSAGEAsientosContablesSinHoras();
          }
        }
      }
    },
    getSAGEAsientosContablesConHoras() {
      let secondsDesde = moment(this.datefrom).startOf("day").unix();
      let secondsHasta = moment(this.dateto).endOf("day").unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        this.loading = true;

        let fechaDesHours = moment(this.hoursfrom).format("HH:mm:ss");
        let fechaHastHours = moment(this.hoursto).format("HH:mm:ss");

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
            idTpv: this.idsTPV,
            //datefrom: secondsDesde,
            //dateto: secondsHasta,
            //hoursfrom: fechaDesHours,
            //hoursto: fechaHastHours,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "importacion/getSAGEAsientosContables",
            config
          )
          .then(function (response) {
            vm.listSage = response.data.result;

            vm.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getSAGEAsientosContablesSinHoras() {
      let secondsDesde = moment(this.datefrom).startOf("day").unix();
      let secondsHasta = moment(this.dateto).endOf("day").unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        this.$store.dispatch("setDateTo", this.dateto);
        this.$store.dispatch("setDateFrom", this.datefrom);

        this.loading = true;

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
            idTpv: this.idsTPV,
            datefrom: secondsDesde,
            dateto: secondsHasta,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(
            this.$store.getters.apiUrl + "importacion/getSAGEAsientosContables",
            config
          )
          .then(function (response) {
            vm.listSage = response.data.result;

            vm.loading = false;

            // console.log(vm.listSage);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    descargarTxtSage(idTpv, idDay) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idTpv: idTpv,
          idDay: idDay,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl +
            "importacion/importarSAGEAsientosContables",
          config
        )
        .then(function (response) {
          download(response.data.result, "sage.txt", "text/plain");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.fa-file-download {
  font-size: 25px;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.trDay:hover {
  background-color: rgba(68, 125, 247, 0.2) !important;
}
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Sage/PlanDeCuentas.vue